"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sdkVersion = require("../../package.json").version;
const uuid_1 = require("uuid");
const events_1 = require("events");
const rpc_websockets_1 = require("rpc-websockets");
const logging_1 = __importDefault(require("../logging"));
class Signaling extends events_1.EventEmitter {
    constructor(diagnosticsBatcher) {
        super();
        this.defaultWebsocketUrl = "wss://device.webrtc.bandwidth.com";
        this.ws = null;
        this.uniqueDeviceId = uuid_1.v4();
        this.hasSetMediaPreferences = false;
        if (diagnosticsBatcher) {
            this.diagnosticsBatcher = diagnosticsBatcher;
            this.diagnosticsBatcher.on("diagnostics", this.sendDiagnostics.bind(this));
        }
    }
    connect(authParams, options) {
        return new Promise((resolve, reject) => {
            let rtcOptions = {
                websocketUrl: this.defaultWebsocketUrl,
            };
            if (options) {
                rtcOptions = { ...rtcOptions, ...options };
            }
            const websocketUrl = `${rtcOptions.websocketUrl}/v3/?token=${authParams.deviceToken}&client=browser&sdkVersion=${sdkVersion}&uniqueId=${this.uniqueDeviceId}`;
            logging_1.default.debug(`Connecting to ${websocketUrl}`);
            const ws = new rpc_websockets_1.Client(websocketUrl, {
                max_reconnects: 0,
            });
            this.ws = ws;
            ws.on("sdpOffer", (event) => {
                this.emit("sdpOffer", event);
            });
            ws.on("open", async () => {
                logging_1.default.debug("Websocket open");
                if (globalThis.addEventListener) {
                    globalThis.addEventListener("beforeunload", (event) => {
                        this.disconnect();
                    });
                }
                if (!this.hasSetMediaPreferences) {
                    await this.setMediaPreferences();
                    this.hasSetMediaPreferences = true;
                }
                this.pingInterval = setInterval(() => {
                    ws.call("ping", {});
                }, 300000);
                logging_1.default.debug("Websocket ready");
                resolve();
            });
            ws.on("error", (error) => {
                // TODO: make this a more informative error message
                logging_1.default.error(`Websocket error: ${JSON.stringify(error)}`);
                if (this.pingInterval) {
                    clearInterval(this.pingInterval);
                }
            });
            ws.on("close", (code) => {
                logging_1.default.debug(`Websocket closed: ${code}`);
                if (this.pingInterval) {
                    clearInterval(this.pingInterval);
                }
            });
        });
    }
    disconnect() {
        logging_1.default.debug("Disconnecting websocket");
        if (this.ws) {
            this.ws.notify("leave");
            if (this.diagnosticsBatcher) {
                const finalDiagnostics = this.diagnosticsBatcher.getDiagnostics();
                this.sendDiagnostics(finalDiagnostics);
            }
            logging_1.default.debug("Setting hasSetMediaPreferences to false");
            this.hasSetMediaPreferences = false;
            this.ws.removeAllListeners();
            this.ws.close();
            this.ws = null;
        }
        if (this.pingInterval) {
            clearInterval(this.pingInterval);
        }
    }
    offerSdp(sdpOffer, metadata) {
        var _a;
        logging_1.default.debug(`Calling "offerSdp"`, { sdpOffer: sdpOffer, mediaMetadata: metadata });
        return (_a = this.ws) === null || _a === void 0 ? void 0 : _a.call("offerSdp", {
            sdpOffer: sdpOffer,
            mediaMetadata: metadata,
        });
    }
    answerSdp(sdpAnswer) {
        var _a;
        logging_1.default.debug(`Calling "answerSdp"`, { sdpAnswer: sdpAnswer });
        return (_a = this.ws) === null || _a === void 0 ? void 0 : _a.call("answerSdp", {
            sdpAnswer: sdpAnswer,
        });
    }
    setMediaPreferences() {
        var _a;
        logging_1.default.debug(`Calling "setMediaPreferences"`, { protocol: "WEBRTC" });
        return (_a = this.ws) === null || _a === void 0 ? void 0 : _a.call("setMediaPreferences", {
            protocol: "WEBRTC",
        });
    }
    sendDiagnostics(diagnostics) {
        var _a;
        logging_1.default.debug(`Calling "deviceDiagnostics"`);
        return (_a = this.ws) === null || _a === void 0 ? void 0 : _a.notify("deviceDiagnostics", diagnostics);
    }
}
exports.default = Signaling;
//# sourceMappingURL=signaling.js.map